import { render, staticRenderFns } from "./TrustList.vue?vue&type=template&id=3bc9b316&scoped=true"
var script = {}
import style0 from "./TrustList.vue?vue&type=style&index=0&id=3bc9b316&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc9b316",
  null
  
)

export default component.exports